import {PageSwapCommand} from "./PageSwapCommand";


export class RevisionCommand extends PageSwapCommand {
    async pullChanges() {
        await super.pullChanges(this.component.path());
    }

    get component () {
        return this._pageEngineComponent
    }
}